import { createCrudHooks } from './base'
import type {
  MaintenanceLogWithRelations,
  MaintenanceLog,
  CreateMaintenanceLog,
  UpdateMaintenanceLog,
} from '@markku/types'

export const maintenanceLogHooks = createCrudHooks<
  MaintenanceLogWithRelations,
  MaintenanceLog,
  CreateMaintenanceLog,
  UpdateMaintenanceLog
>('maintenanceLog')
